import type { PcsCard } from './pcs-card.type.ts';
export interface PcsCardExtension extends PcsCard {}
export class PcsCardExtension {
  // ── Computed ──
  get isActive() {
    return this.state === 'PCS.CardState.ACTIVATED';
  }

  get isDeactivated() {
    return this.state === 'PCS.CardState.INACTIVATED' || this.state === 'PCS.CardState.CANCELED';
  }
}

const Registration = {
  kind: 'object',
  name: 'pcs-card',
  features: PcsCardExtension,
};
export default Registration;
